import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AutocompleteLibComponent } from 'angular-ng-autocomplete';
import { GetOriginsInput } from '../../../../shared/models/lead/getOrigins.input';
import { RolType } from '../../../../shared/models/types/rol.types';
import { UserLogged } from '../../../../shared/models/user.logged.model';
import { EventService } from '../../../../shared/services/event/event.service';
import { LeadService } from '../../../../shared/services/lead/lead.service';
import { AuthService } from '../../../../shared/services/security/auth.service';
import { TranslatorService } from '../../../../shared/services/utils/translator.service';
import { DropdownWithRulesInput } from './../../../../shared/models/lead/dropdownWithRules.input';

@Component({
  selector: 'ngx-origin-autocomplete',
  templateUrl: 'origin-autocomplete.html',
  styles: [':host { flex: 1 1 auto; width: 1%; }']
})
export class OriginAutocompleteComponent implements OnInit, OnChanges {

  @Input() createNewText: boolean;
  @Input() selectedItem: string;
  @Input() channel: string;
  @Input() dropdownWithRules: boolean;
  origins: string[] = [];
  canCreateNew: boolean;
  isInOrigins = false;
  rolType: RolType = new RolType();
  @Input() comingFromEditForm: boolean;

  @ViewChild(AutocompleteLibComponent, { static: false }) autocompletable: any;
  notFound: string;
  mustHaveValidValue: any;

  constructor(
    private readonly leadService: LeadService,
    private readonly translationService: TranslatorService,
    private readonly eventService: EventService,
    readonly authService: AuthService,
  ) { }

  ngOnInit(): void {
    if (this.comingFromEditForm) {
      this.canCreateNew = true;
    }
    this.notFound = this.createNewText ?
      this.translationService.trans('shared.create_new_origin') :
      this.translationService.trans('shared.label_not_found');

    const user = this.authService.getUser();
    if (this.userHasEnabledDropdownWithRules(user)) {
      this.getOrigins();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedItem) {
      this.selectedItem = changes.selectedItem.currentValue;
    }
  }

  updateValue(value: string): void {
    if (this.canCreateNew) {
      this.selectedItem = value;
    } else {
      this.isInOrigins = !this.origins.includes(value);
      this.eventService.broadcast('canSubmitOrigin', {
        canCreateNew: this.canCreateNew,
        isInOrigins: value ? this.origins.includes(value) : false
      });
      if (this.isInOrigins) {
        this.selectedItem = value;
      }
    }
  }

  getOrigins(): void {
    this.leadService.getOrigins$(
      new GetOriginsInput(''),
      new DropdownWithRulesInput(this.channel, this.dropdownWithRules)
    ).subscribe(response => {
      this.origins = response.origins;
      this.canCreateNew = response.canCreateNew;
      if (!this.comingFromEditForm) {
        this.eventService.broadcast('canSubmitOrigin', { canCreateNew: this.canCreateNew, isInOrigins: false });
      }
      this.comingFromEditForm = false;
      this.updateNotFoundText();
    });
  }

  onDeselectedItem() {
    this.comingFromEditForm = false;
    this.getOrigins();
    this.updateValue('');
  }

  private updateNotFoundText() {
    this.notFound = this.canCreateNew ?
      this.translationService.trans('shared.create_new_origin') :
      this.translationService.trans('shared.label_not_found');
  }

  private userHasEnabledDropdownWithRules(user: UserLogged) {
    return (user.company && user.company.companyConfiguration.dropdownWithRules) && this.dropdownWithRules;
  }
}
